export const Logo = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Niagara Callback logo">
    <rect width="64" height="64" fill="#FFD700" />
    <path d="M10 12h44v26H32l-10 10V38H10z" fill="#0A0A0A" />
    <path d="M20 25h16a6 6 0 0 1 6 6v3" stroke="#FFD700" strokeWidth="4.5" fill="none" />
    <path d="M26 19l-6 6 6 6" stroke="#FFD700" strokeWidth="4.5" fill="none" />
  </svg>
);
